import { IForumPost } from '@dtos/Comment'
import { formatRelative } from '@utils/dateFormatter'
import { Text, YStack } from 'tamagui'
import { AuthorBadge } from './AuthorBadge'

interface IPostItemProps {
  post: IForumPost
}

export function PostItem({ post }: IPostItemProps) {
  return (
    <YStack
      gap="$spacing-inset-xs"
      p="$spacing-inset-sm"
      borderRadius="$border-radius-sm"
      backgroundColor="$neutral-50"
      testID={`forum-post-${post.id}`}
    >
      <AuthorBadge user={post.user} size={28} />
      <Text
        fontFamily="$mulishRegular"
        fontSize="$font-size-xxs"
        color="$text-primary"
      >
        {post.body}
      </Text>
      <Text
        fontFamily="$mulishRegular"
        fontSize="$font-size-xxxs"
        color="$text-placeholder"
      >
        {formatRelative(post.createdAt)}
      </Text>
    </YStack>
  )
}
